/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchOperationFailureDto
 */
export interface BatchOperationFailureDto {
    /**
     * Request ID that failed
     * @type {string}
     * @memberof BatchOperationFailureDto
     */
    id: string;
    /**
     * Reason for failure
     * @type {string}
     * @memberof BatchOperationFailureDto
     */
    reason: string;
}

/**
 * Check if a given object implements the BatchOperationFailureDto interface.
 */
export function instanceOfBatchOperationFailureDto(value: object): value is BatchOperationFailureDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function BatchOperationFailureDtoFromJSON(json: any): BatchOperationFailureDto {
    return BatchOperationFailureDtoFromJSONTyped(json, false);
}

export function BatchOperationFailureDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchOperationFailureDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'reason': json['reason'],
    };
}

export function BatchOperationFailureDtoToJSON(json: any): BatchOperationFailureDto {
    return BatchOperationFailureDtoToJSONTyped(json, false);
}

export function BatchOperationFailureDtoToJSONTyped(value?: BatchOperationFailureDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'reason': value['reason'],
    };
}

